// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vPXT","question":"styles_question__ndmet","description":"styles_description__2KMrB"};